<mat-form-field class="filter-field">
  <mat-label class="filter-content">Search project</mat-label>
  <input
    matInput
    name="searchProject"
    (input)="searchChangedEvent()"
    class="filter-text-spacer"
    [formControl]="seachControl"
    [matAutocomplete]="auto"
    #searchInput />
  <mat-icon matPrefix class="filter-icon">search</mat-icon>

  <button
    mat-button
    *ngIf="searchInput.value"
    matSuffix
    mat-icon-button
    aria-label="Clear"
    (click)="seachControl.reset()"
    (click)="clearInput()">
    <mat-icon>close</mat-icon>
  </button>

  <mat-autocomplete #auto="matAutocomplete">
    <mat-option (click)="optionClicked(searchInput)" *ngFor="let name of filter$ | async" [value]="name">
      {{ name }}
    </mat-option>
  </mat-autocomplete>
</mat-form-field>
